import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, NgZone, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationMessage, NotificationService, NotificationTypeEnum } from '@xpo-ltl/data-api';
import { XpoNotificationTemplate, XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SnackbarStatus } from './shared/enums/snackbar-status.enum';

@Component({
  selector: 'xpo-app-notification',
  templateUrl: './app-notification.component.html',
  styleUrls: ['./app-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
})
export class NotificationComponent implements OnInit, OnDestroy {
  message: string;
  show: boolean;

  @Input()
  showProgressSpinner = true;

  private unsubscribe = new Subject<void>();
  private snackBarRef: MatSnackBarRef<XpoNotificationTemplate>;

  constructor(
    private notificationService: NotificationService,
    private zone: NgZone,
    private snackbar: XpoSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.notificationService
      .getSubscriber()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((message: NotificationMessage) => {
        try {
          this.zone.run(() => {
            if (message.type !== NotificationTypeEnum.ShowSnackbar) {
              this.message = typeof message.text === 'string' ? message.text : '';
              this.show = message.type === NotificationTypeEnum.ShowOverlay;
            } else {
              const messageText = typeof message.text === 'string' ? message.text : '';
              this.snackBarRef = this.snackbar.open({
                message: messageText,
                status: SnackbarStatus[message.status],
                action:
                  message.actionHandler != null && message.actionHandler.actionLabel() != null
                    ? message.actionHandler.actionLabel()
                    : null,
                matConfig: {
                  duration: message.durationInMillis,
                },
              });

              if (message.actionHandler != null) {
                if (message.actionHandler.onAction != null) {
                  this.snackBarRef.onAction().subscribe(message.actionHandler.onAction);
                }
                if (message.actionHandler.afterOpened != null) {
                  this.snackBarRef.afterOpened().subscribe(message.actionHandler.afterOpened);
                }
                if (message.actionHandler.afterDismissed != null) {
                  this.snackBarRef.afterDismissed().subscribe(message.actionHandler.afterDismissed);
                }
              }
            }
            this.cdr.detectChanges();
          });
        } catch (error) {
          // todo: log
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
